export const Colors = {
  transparent: 'transparent',
  purple: '#8052FF',
  blue: '#4400FF',
  'blue-light': '#108EE9',
  cyan: '#2EFFE3',
  salmon: '#f97075',
  magenta: '#FF46FF',
  yellow: '#FFFF00',
  orange: '#FFB400',
  green: '#00ff43',
  red: '#FF0707',
  'red-pastel': '#F17373',
  'gray-darkest': '#221f20',
  'gray-dark': '#979797',
  'gray-brand': '#BFBFBF',
  'gray-light': '#DDDDDD',
};
